import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import {environment} from "../../../environments/environment";

declare var LeaderLine: any;

@Injectable({
  providedIn: 'root'
})
export class PrettyLineService implements OnInit, OnDestroy {

  elements: HTMLElement[] = [];
  lines: any[] = [];
  unsubscribe$: Subject<void> = new Subject();

  constructor(

  ) {

  }

  get isParacelsus() {
    return environment.style === 'paracelsus'
  }

  clearLine() {
    this.lines.forEach(l => l.remove());
    this.lines.length = 0;
    this.elements.length = 0;
  }

  drawLine(elements: HTMLElement[], options?: any) {
    setTimeout(() => {
      elements = elements.sort(this.orderElements);
      for (let i = 0; i < elements.length - 1; i++) {
        const line = new LeaderLine(elements[i], elements[i + 1], {
          startSocket: i ? 'bottom' : 'left',
          endSocket: 'top',
          startPlug: 'arrow1',
          startPlugSize: .1,
          endPlugSize: .1,
          endPlug: 'arrow1',
          color: this.isParacelsus ? '#B81647': '#195ea0',
          path: 'grid',
          dash: {len: 3, gap: 3}});
        this.lines.push(line);
      }
    }, 0)
  }

  drawPrettyLine () {
    if (this.elements.length < 2) {
      return;
    }
    this.drawLine(this.elements);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {

  }

  reDrawPrettyLine() {
      this.clearLine();
      const emTitle = document.querySelector('[name=em-title]') as HTMLElement;
      if (emTitle) {
        this.setElement(emTitle);
      }
      const emSteps = Array.from(document.querySelectorAll('[name=em-step-icon]'));
      emSteps.forEach((emStep) => this.setElement(emStep as HTMLElement));
      this.drawPrettyLine();
  }

  setElement(element: HTMLElement) {
    if(this.elements.indexOf(element) > -1) {
      return;
    }
    this.elements.push(element);
  }

  updatePrettyLine() {
    this.lines.forEach(l => l.position());
  }

  private orderElements(a: HTMLElement, b: HTMLElement) {
      const aOrder = a.attributes.getNamedItem('em-step-order') || 0;
      const bOrder = b.attributes.getNamedItem('em-step-order') || 0;
      if(aOrder > bOrder) {
        return 1;
      };
      return 0;
  }

}
